import { message } from 'antd'
import axios from 'axios'

export const fileDownload = ({ url, name, type = '' }: { url: string; name: string; type?: string }) => {
  axios({
    url: url,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    try {
      const url = window.URL.createObjectURL(new Blob([response.data], { type }))
      const link = document.createElement('a')
      link.setAttribute('download', name)
      link.setAttribute('href', url)
      link.click()
      link.remove()
      message.info(`正在下载 ${name}，请查看浏览器下载栏`, 10)
    } catch (e) {
      console.error(e)
    }
  })
}
